exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ocrResults[data-v-1b8bc39d] {\r\n  border: 1px solid silver;\r\n  border-collapse: separate;\r\n  border-spacing: 0;\r\n  border-radius: 0 0 15px 15px;\r\n  overflow: hidden;\r\n  width: 100%;\n}\n.ocrResults th[data-v-1b8bc39d] {\r\n  background-color: black;\r\n  border: 1px solid silver;\r\n  color: white;\r\n  font-weight: normal;\r\n  height: 40px;\n}\n.ocrResults tbody tr td[data-v-1b8bc39d] {\r\n  border-top: 1px solid silver;\r\n  padding-top: 5px;\r\n  padding-bottom: 5px;\n}\n.ocrResults tbody tr td[data-v-1b8bc39d],.ocrResults thead th[data-v-1b8bc39d] {\r\n  text-align: center;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1b8bc39d","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/requests/OCRListPage.vue
// module id = 1542
// module chunks = 2